import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

function quote_split() {
    const quoteBlocks = document.querySelectorAll('[data-block="quote"]');
    if (!quoteBlocks.length) { return; }
    
    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(SplitText);
    
    quoteBlocks.forEach(quoteBlock => {
        // Find the quote text element to animate
        const quoteText = quoteBlock.querySelector('[data-name="quote-split"]');
        if (!quoteText) return;
        
        // Split text for character-by-character animation
        const quoteTextSplit = new SplitText(quoteText, {
            type: "chars, words",
            linesClass: "char",
        });
        
        // Create animation timeline with ScrollTrigger
        const splitTextTL = gsap.timeline({
            scrollTrigger: {
                trigger: quoteBlock,
                start: "top 90%", // Start animation when the top of the block reaches 75% of viewport
                end: "bottom 50%", // End animation when the bottom of the block reaches 25% of viewport
                toggleActions: "play none none reverse", // Play on enter, reverse on leave
                scrub: true,
            },
        });
        
        // Character-by-character fade in animation
        splitTextTL.from(quoteTextSplit.chars, { 
            opacity: 0.2, 
            stagger: 0.01, // Slightly increased stagger for more visible effect
            ease: "power1.out",
            duration: 0.5
        });
        
       
    });
}

export { quote_split }; 